export default {
  namespaced: true,
  state: {
    logs: []
  },
  mutations: {
    init: (state, content) => { state.logs = content.reverse() },
    add: (state, content) => { state.logs.unshift(content) }
  },
  getters: {
    list: (state) => state.list
  }
}
